import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SetOfflineDialog } from '../../ActionCreators'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import { getUnavailableOfflineDialog } from '../../Selectors'
import styles from './VNUnavailableOffline.module.scss'
import CloudOffIcon from '@material-ui/icons/CloudOff'
import { APPLICATION_STRINGS } from '../../../strings'

/**
 * Modal for when attempting to print to cloud printer while offline
 *
 * @link https://www.figma.com/design/c2daBWS1vGCMSVb1zfSQpO/Quick-Service?node-id=13407-56149
 * @returns {React.Element}
 */
export const VNCloudPrinterUnavailableOffline = () => {
  const dispatch = useDispatch()
  const dialogOptions = useSelector(getUnavailableOfflineDialog)

  const cancelHandler = useCallback(() => {
    dispatch(SetOfflineDialog(false))
  }, [dispatch])

  if (!dialogOptions?.get('open')) {
    return null
  }

  return (
    <ConfirmModalV2
      classNames={{ confirmModalV2: styles.confirmModalV2, container: styles.container, headerText: styles.headerText }}
      icon={<CloudOffIcon fontSize="large" />}
      onButtonTwoClick={cancelHandler}
      headerText={dialogOptions.get('message')}
      buttonTwoText={APPLICATION_STRINGS.OKAY_BUTTON_TEXT}
      singleButtonOnly
    />
  )
}
